import React, { Component } from "react";
import { connect } from "react-redux";
import {
  onAddressFormChange,
  copySuggestAddress,
  onAutoFillSelect,
  onSuggestAddressBlur
} from "../../../redux/actions/address";
import AutoFillAddress from "../../../components/AutoFillAddress";
import Button from "@material-ui/core/Button";
import { enableBack, goNext } from "../../../redux/actions/stepper";
import FormLabel from "@material-ui/core/FormLabel";
import locale from "../../../utils/locale";
import Form from "../../../components/form/Form";
import { handlePickupFormChange } from "../../../redux/actions/pickupForm";
import validate from "../../../utils/validate";
import renderIf from "../../../utils/renderIf";

const style = {
  background: '#0A5DB8',
};

class PickupAddress extends Component {
  state = {
    error: false,
    errorMessage: ""
  };
  handleAddressChange = address => {
    this.validateFn(address);
    // this.setState(() => errorObj);
  };
  componentWillMount() {
    window.scrollTo(0, 0);
    //enable back
    this.props.enableBack();
  }

  validateFn = value => {
    let errorObj = validate(value, this.props.fields["addressLine1"].required);
    this.setState(() => errorObj);
    this.props.handlePickupFormChange("addressLine1", value, errorObj.error);
  };

  render() {
    const {
      stepTitle,
      stepIntroText,
      pickupAddress,
      stepFields,
      fields,
      copySuggestAddress,
      geoSuggestAddress,
      onAddressFormChange,
      onAutoFillSelect,
      onSuggestAddressBlur,
      errors,
      goNext,
      handlePickupFormChange,
      showErrors
    } = this.props;
    return (
      <div>
        {renderIf(stepTitle)(
          <div className="intro-title">{stepTitle}</div>
        )}
        {renderIf(stepIntroText)(
          <div className="intro-text">{stepIntroText}</div>
        )}
        <div className="step-form">
          {geoSuggestAddress.isPartialMatch && geoSuggestAddress.addressLine1 && geoSuggestAddress.city && geoSuggestAddress.state && geoSuggestAddress.zip? (
            <div className="copy-address">
              <strong>{locale("addressNotMatched")}</strong>
              <p>{geoSuggestAddress.addressLine1}</p>
              <p>{geoSuggestAddress.addressLine2}</p>
              <p>
                {geoSuggestAddress.city},{geoSuggestAddress.state}
              </p>
              <p>{geoSuggestAddress.zip}</p>
              <Button
                className="br-25"
                onClick={copySuggestAddress}
                variant="raised"
                color="primary"
                fullWidth
                style={style}
              >
                <strong>{locale("useSuggestedAddress")}</strong>
              </Button>
            </div>
          ) : (
              ""
            )}
          <div className="address-form-field">
            <AutoFillAddress
              type={["geocode"]}
              country="US"
              ignoreTab
              required
              initialValue={fields["addressLine1"].value}
              onSuggestSelect={onAutoFillSelect}
              onChange={this.handleAddressChange}
              placeholder={locale("addressLine1")}
            />
            {this.state.error ? (
              <span className="error-text">({this.state.errorMessage})</span>
            ) : (
                ""
              )}
          </div>
          <Form
            fieldsStructure={stepFields}
            fields={fields}
            handleFieldChange={handlePickupFormChange}
            showErrors={showErrors}
          />
          <div className="address-form-field">
            <Button
              className="br-25 "
              onClick={goNext}
              variant="raised"
              color="primary"
              fullWidth
              style={style}
            >
              <strong>{locale("useMyAddress")}</strong>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pickupAddress: state.address.pickupAddress,
  geoSuggestAddress: state.address.geoSuggestAddress,
  errors: state.address.errors,
  fields: state.pickupForm.fields,
  showErrors: state.pickupForm.currentStepError
});

const mapDispatchToProps = {
  onAddressFormChange,
  onAutoFillSelect,
  onSuggestAddressBlur,
  copySuggestAddress,
  enableBack,
  goNext,
  handlePickupFormChange
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PickupAddress);



// WEBPACK FOOTER //
// ./src/containers/PickupForm/steps/PickupAddress.js